import styled from "@emotion/styled"

const ProfileName = styled.h4`
  font-weight: 700;
  padding: 8px;
`
export default ProfileName
